export default "__VITE_ASSET__fa260899__"